module.exports = __webpack_public_path__ + "static/28-THE-BOOMING-STATE-OF-THE-PROPTECH-INDUSTRY-28e0734d3867daafb7cfce61c3c03b46.jpg";